import React, { Component } from 'react';
import TopBar from '../../components/TopBar';
import BottomBar from '../../components/BottomBar';
import './Linker.css';
import '../styles.css';

/* Titles */
const title2 = 'Annen informasjon:';
const title3 = 'Film til bruk sammen med rød dialogduk';
const title4 = 'Filmer til bruk sammen med blå dialogduk'; // den nye som kommer
const youtubeTitle = 'Se filmen på YouTube';
/* End of titles */

/* Linker */
const linker = {

  'https://bfk.no/tjenester/skole-og-opplaring/ombudet-for-barn-og-unge': "Ombudet for barn og unge i Akershus, Buskerud og Østfold",
  'https://www.medietilsynet.no':
    'Medietilsynet',
  'http://www.specifique.no': 'Specifique',
};
const youtubeLink = 'https://youtu.be/yBeotNlvVas';

/* End of Linker */

const otherInformation = () => (
  <div className="Linker-other-container">
    <div className="Linker-white-container">
      <div className="Linker-column-container">
        <div className="Linker-title-type2">{title2}</div>
        <div className="Linker-links-container">
          {Object.keys(linker).map((link, index) => (
            <a
              className="Linker-link-text"
              href={link}
              key={index}
              target="_blank">
              {linker[link]}
            </a>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const videos = () => (
  <div className="Linker-videos-container">
    <div className="Linker-column-container">
      <div className="Linker-heading" style={{
        color: '#000',
        fontSize: '30px',
        fontWeight: 700,
        paddingBottom: 60,
      }}>Filmer brukt sammen med dialogduker</div>
      <div className="Linker-title-type2">{title3}</div>
      <div className="Empty-space-28" />
      <div className="Linker-subtitle">Oppgave 2</div>
      <div className="Youtube-container">
        <iframe
          id="ytplayer"
          title="ytplayer"
          type="text/html"
          width="426"
          height="240"
          src="https://www.youtube.com/embed/yBeotNlvVas"
          frameBorder="0"
          allowFullScreen
        />
      </div>
      <a
        href={youtubeLink}
        target="_blank"
        style={{
          width: 'fit-content',
          textAlign: 'left',
          display: 'block',
          paddingTop: '15px',
          cursor: 'pointer',
          color: '#00628d',
        }}>
        {youtubeTitle}
      </a>
      <div className="Linker-row">
        <div className="Linker-title-type2">{title4}</div>
        <div className="Empty-space-28" />
        <div className="Linker-column">
          <div className="Linker-subtitle">Oppgave 2</div>

          <div className="Youtube-container">
            <iframe
              title="youtube2"
              src="https://www.youtube.com/embed/eDlco2s-010"
              width="426"
              height="240"
              frameBorder="0"
              allowFullScreen></iframe>
          </div>
          <a
            href="https://youtu.be/eDlco2s-010"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: 'pointer',
              color: '#00628d',
              textAlign: 'left',
              display: 'block',
              paddingTop: '15px',
              paddingBottom: 20,
            }}>
            {youtubeTitle}
          </a>
        </div>
        <div className="Linker-empty-column" />
        <div className="Linker-column">
          <div className="Linker-subtitle">Oppgave 4</div>
          <div className="Youtube-container">
            <iframe
              title="youtube3"
              src="https://www.youtube.com/embed/t5IfJkaw94w?si=PZbjIO5i3srMvOOU"
              width="426"
              height="240"
              frameBorder="0"
              allowFullScreen></iframe>
          </div>
          <a
            href=" https://youtu.be/t5IfJkaw94w"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: 'pointer',
              color: '#00628d',
              textAlign: 'left',
              display: 'block',
              paddingTop: '15px',
            }}>
            {youtubeTitle}
          </a>
        </div>
      </div>
      <div className="Linker-spacer" />
    </div>
    {otherInformation()}
  </div>
);

class Links extends Component {
  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.playVideo();
    event.target.pauseVideo();
  }

  render() {
    return (
      <div className="OuterContainer">
        <div style={{ diplay: 'block' }}>
          <TopBar activePage={'Nyttige linker'} />
        </div>
        <div className="Container-cinderella">
          <div className="Linker-container">
            <div className="Linker-inner-container">{videos()}</div>
          </div>
        </div>
        <BottomBar />
      </div>
    );
  }
}

export default Links;



// WEBPACK FOOTER //
// ./src/pages/Linker/index.js